<template>
    <div class="product_page" ref="productPage">

        <b-breadcrumb :items="items"></b-breadcrumb>


        <div class="tabs">
            <div class="tab" v-for="(item,index) in tabsList" :class="{'active':currentTab.id === item.id}"
                 @click="switchTab(item)" :key="index">
                <div class="box_inner" v-if="index === 0 || ((index === tabsList.length-1) && index > 0)">
                    {{ item.name }}
                </div>
                <span v-if="index > 0 && (index < tabsList.length-1)">{{ item.name }}</span>
            </div>
        </div>

        <b-container class="product_box">
            <transition name="fade">
                <b-row v-if="productList.length">
                    <b-col class="item" md="6" lg="5" xl="4" v-for="item in productList"
                           @click="goDetail(item)" :key="item.id">
                        <img src="../assets/p-b.png" class="bg_img">
                        <div class="product_img">
                            <img :src="api+item.background">
                        </div>
                        <div class="more">
                            <div class="clearfix">
                                <div class="left clamp1">
                                    {{ item.name }}
                                </div>
                                <div class="right">
                                    MORE
                                    <img src="../assets/arrow.png">
                                </div>

                                <img src="../assets/new_more1.png" width="100%">

                            </div>
                        </div>
                    </b-col>
                </b-row>
            </transition>
        </b-container>
    </div>
</template>

<script>

    import {api} from '../api/api';
    import {getGoods} from '../api/HomeService'
    import {getTypeList} from '../api/HomeService'

    export default {
        name: "Product",
        data() {
            return {
                items: [
                    {
                        text: 'Admin',
                        href: '#'
                    },
                    {
                        text: '',
                        href: '#'
                    },
                    {
                        text: '',
                        active: true
                    }
                ],
                tabsList: [],
                currentTab: {},
                languageNum: window.localStorage.getItem("languageNum"),
                productList: [],
                api: api
            }
        },
        methods: {
            goDetail(item) {
                document.title = item.name;
                this.$router.push('/product/detail?id=' + item.id)
            },

            switchTab(item) {
                this.$router.push("/zh/products?type=" + item.name);
                this.items[1].text = item.name

            },

            getTypeList() {
                let sendData = {
                    languageNum: this.languageNum,
                    classType: 6
                }
                getTypeList(sendData, data => {
                    if (this.$route.query.type) {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].name === this.$route.query.type) {
                                this.currentTab = data[i];
                                console.log(this.currentTab)
                                break;
                            }
                        }
                    } else {
                        this.currentTab = data[0];
                    }

                    this.getGoodsList()
                    this.tabsList = data;
                })
            },

            getGoodsList() {
                let sendData = {
                    languageNum: this.languageNum,
                    pageNum: 1,
                    pageSize: 99,
                    typeId: this.currentTab.id
                }
                getGoods(sendData, data => {
                    this.productList = data.rows;
                    this.curProduct = this.productList[0]
                })
            },
        },
        mounted() {
            this.getTypeList();
            this.$refs.productPage.style.minHeight = document.documentElement.clientHeight - 409 + 'px'

            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].menuUrl === '/products') {
                    this.items[0].text = menuList[i].menuNam;
                }
            }

            this.items[1].text = this.$route.query.type

        }

    }
</script>

<style scoped lang="scss" src="../css/product.scss">

</style>